import React, {Component} from "react";
import {AgGridColumn, AgGridReact} from "ag-grid-react";

import './PendingView.css';
import ExtAppService, {ExtAppToIntApp} from "../../api/services/ExtAppService";
import moment from "moment-timezone";
import momentDurationFormatSetup from "moment-duration-format";
import Icon from "../../components/Icon";
import {SanitizeClassNames} from "../../common";
import RootModal from "../../components/RootModal";
import {YesNoModal} from "../../components/ModalFactory";
import ClientLinkForm from "../Clients/forms/ClientLinkForm";
import {FormLabeledItem} from "../../components/FormUI";
import DateHelper from "../../components/DateHelper";
import Clinic from "../../api/Clinic";
import NewAppForm from "../Appointments/forms/NewAppForm";
import obj from "lodash/object"
import CalendarView from "../CalendarView";
import Helper from "../../classes/Helper";
import PatientService from "../../api/services/PatientService";
import UserService from "../../api/services/UserService";

momentDurationFormatSetup(moment);

/**
 * Converts UTC Date string to current timezone moment
 * @param dateString
 * @returns moment
 */
const getTZDate = (dateString) => {
	return moment.tz(dateString, 'UTC').tz(moment.tz.guess());
}

const dateFormatter = (params) => {
	console.log('dateFormatter Params', params)
	//const d = moment.tz(params.value, 'UTC');
	return moment(params.value).format('MMM Do, YYYY');
}

const timeFormatter = (params) => {
	//const d = moment.tz(params.value, 'UTC');
	return moment(params.value).format('h:mma z');
}

const durationFormatter = (params) => {
	const d = moment.duration(params.value, 'minute');
	return d.format('hh:mm', {
		trim: false
	});
}

const clientNameFormatter = (data) => {
	return `${data.clientFirstName} ${data.clientLastName}`;
}

const sourceFormatter = (data) => {
	return 'Connect';
}

const phoneFormatter = (params) => {
	return Helper.Phone.FormatNumber(params.value);
}

export class ClientNameRenderer extends Component {
	render() {
		const props = this.props;
		console.log('ClientNameRenderer Params:', props);
		const name = `${props.data.clientFirstName} ${props.data.clientLastName}`;
		const isMatched = !!props.data.biopedClientId
		return (
			<span className={isMatched ? '' : 'not-matched'} onClick={() => {
				if (!isMatched) {
					ShowClientLinkForm(props.data);
				}
			}}>{name}</span>
		)
	}
}

export class CellActionButton extends Component {
	render() {
		return (
			<div className={SanitizeClassNames(this, 'cell-action-btn')} title={this.props.title}
			     onClick={this.props.onClick}><Icon {...this.props} /></div>
		)
	}
}

const ShowClientLinkForm = (appData) => {
	const modalId = RootModal.ShowModal(<ClientLinkForm client={appData} onSave={()=>{
		ExtAppService.UpdatePending();
		RootModal.CloseModal(modalId)
	}} />, null, {
		onRequestClose: () => {
			RootModal.CloseModal(modalId);
		},
		title: (
			<div className={'modal-title'}>
				<span className={'align-left'}>Link Client - {clientNameFormatter(appData)}</span>
				<span className={'text-btn'} onClick={() => RootModal.CloseModal(modalId)}>Cancel</span>
			</div>
		),
		className: "client-link-form-modal"
	});
}

export const ShowRejectConfirmModal = (appData) => {
	console.log('ShowRejectConfirmModal:', appData)
	const modalId = RootModal.ShowModal(
		<YesNoModal yesCaption={'Yes - Reject'} noCaption={'No - Close'} onChoice={(yes) => {
			if(yes) {
				appData.status = 'Cancelled';
				ExtAppService.UpdateAppointment(appData).finally(()=>{
					ExtAppService.UpdatePending();
					CalendarView.Refresh();
				});
			}
		}}>
			{ExtAppView(appData)}
			<br />
			<h2>Are you sure you want to reject this appointment from OnCall?</h2>
			<br />
		</YesNoModal>,
		null,
		{
			onRequestClose: () => {
				RootModal.CloseModal(modalId);
			},
			title: (
				<div className={'modal-title'}>
					<span className={'align-left'}>Reject Appointment</span>
					<span className={'text-btn'} onClick={() => RootModal.CloseModal(modalId)}>Cancel</span>
				</div>
			),
			className: "client-link-form-modal"
		}
	)
}


const updatePatientPhone = (clientID, phone) => {
	console.log('Update Patient Phone -> clientID:', clientID, '  phone:', phone);
	if(phone) {
		return PatientService.GetById(clientID).then((client) => {
			if(!client.cellPhone && phone) {
				client.cellPhone = Helper.Phone.FormatNumber(phone);
				console.log('Updated Client Cell Phone:', client);
				return UserService.Save(client)
			}
			return client;
		})
	}
}

//ExternalAppointmentId
export const ShowAcceptApp = (appData) => {
	const capp = ExtAppToIntApp(appData);
	capp.status = 'Booked';
	console.log('Converted Ext App:', capp);
	console.log('ShowAcceptApp:', appData);
	const modalId = RootModal.ShowModal(
		<NewAppForm
			appointment={capp}
			onSave={(app)=>{
				console.log('External Appointment Accepted and Created! ', app)
				appData.status = 'Booked';
				ExtAppService.UpdateAppointment(appData).finally(()=>{
					ExtAppService.UpdatePending();
					CalendarView.Refresh();
				});
				updatePatientPhone(app.clientId, appData.clientPhoneNumber);

				RootModal.CloseModal(modalId);

			}}



			buttonCaption={'Confirm Booking'}
		/>,
		null,
		{
			onRequestClose: () => {
				RootModal.CloseModal(modalId);
			},
			title: (
				<div className={'modal-title'}>
					<span className={'align-left'}>Accept {appData.appointmentSourceCode} Appointment</span>
					<span className={'text-btn'} onClick={() => RootModal.CloseModal(modalId)}>Cancel</span>
				</div>
			),
			className: "client-link-form-modal"
		}
	);
}

/**
 * Draws the confirm, reject buttons on the list
 */
export class ActionCellRender extends Component {

	render() {
		const data = this.props.data;
		return (
			<div className={'cell-actions'}>
				<CellActionButton className={'hover-green'} icon={'check'} title={'Approve'}
					onClick={()=> {
						ShowAcceptApp(data);
					}}
				/>
				<CellActionButton className={'hover-red'} icon={'x'} title={'Reject'} onClick={() => {
					ShowRejectConfirmModal(data);
				}}/>
				{/*<CellActionButton icon={'pencil'} title={'Edit'}/>*/}
			</div>
		)
	}
}

export const ExtAppView = (app) => {
	const date = dateFormatter({value: app.startDate});
	const time = timeFormatter({value: app.startDate});
	const duration = durationFormatter({value: app.duration});
	const clientName = clientNameFormatter(app);
	const phone = app.clientPhone;
	const service = app.requestedService;
	const source = app.appointmentSourceCode;
	const email = app.clientEmail;

	let clinic = new Clinic(app.biopedClinicId);


	return (
		<div className="ext-app-view appointment-view">
			<FormLabeledItem label="Client">
				<div className="client-name"><span title='View Details'
				                                   onClick={this.showUserDetails}>{clientName}</span></div>
				<div className="table hmax">
					<div>
						<div>{phone ? "H: " + phone : ''}</div>
						<div className="align-right">{email ? "E: " + email : ''}</div>
					</div>
				</div>
			</FormLabeledItem>
			<FormLabeledItem label='Service'>
				{service}
			</FormLabeledItem>
			<div className="table hmax layout-fixed">
				<div>
					<div>
						<FormLabeledItem label='Date'>
							{moment(app.startDate).format('ddd MMM D, YYYY')}
						</FormLabeledItem>
					</div>
					<div>
						<FormLabeledItem label='Time'>
							{DateHelper.FormatTime(app.startDate)} - {DateHelper.FormatTime(app.endDate)}
						</FormLabeledItem>
					</div>
				</div>
				<div>
					<div>
						<FormLabeledItem label='Pedorthist'>
							{clinic.getDoctor(app.biopedUserId).fullName}
						</FormLabeledItem>
					</div>
					<div>
						<FormLabeledItem label='Status'>
							{app.status}
						</FormLabeledItem>
					</div>
				</div>
			</div>
		</div>
	)
}

export default class PendingView extends Component {

	componentDidMount() {
		if (this.props.onSectionHeader) {
			this.props.onSectionHeader(<h2 className='client-view-section-header'>Pending Appointments</h2>)
		}
	}

	state = {
		rowData: []
	}
	onGridReady = (params) => {
		params.api.sizeColumnsToFit();
		window.addEventListener('resize', function () {
			setTimeout(function () {
				params.api.sizeColumnsToFit();
			});
		});


		/*ExtAppService.AddListener('pending-view', (pending) => {
			this.setState({rowData: pending});
			setTimeout(() => {
				//params.api.sizeColumnsToFit();
			})
		})*/

		/*ExtAppService.GetPending().then((data) => {
			console.log('Pending Data:', data);
			this.setState({rowData: data});
			setTimeout(() => {
				params.api.sizeColumnsToFit();
			})
		})*/

	}

	/*componentWillUnmount() {
		ExtAppService.RemoveListener('pending-view');
	}*/

	render() {
		return (
			<div className={'pending-view ag-theme-alpine'}>
				<AgGridReact
					rowData={this.props.bcApps}
					rowSelection="single"
					defaultColDef={{resizable: true}}
					onGridReady={this.onGridReady}
					animateRows={true}
					domLayout={'autoHeight'}
				>
					<AgGridColumn field="appointmentSourceCode" headerName="Source" sortable={true} valueFormatter={sourceFormatter}/>
					<AgGridColumn field="startDate" headerName="Date" sortable={true} valueFormatter={dateFormatter}/>
					<AgGridColumn field="startDate" headerName="Time" sortable={true} valueFormatter={timeFormatter}/>
					<AgGridColumn field="requestedService" headerName="Service" sortable={true} />
					<AgGridColumn field="duration" headerName="Duration" sortable={true}
					              valueFormatter={durationFormatter}/>
					<AgGridColumn field="client" headerName="Client" sortable={true}
					              cellRendererFramework={ClientNameRenderer}/>
					<AgGridColumn field="clientPhoneNumber" headerName="Cell Phone" sortable={true} valueFormatter={phoneFormatter} />
					<AgGridColumn field="doctorName" headerName="Clinician" sortable={true}/>
					<AgGridColumn field="status" headerName="Status" sortable={true}/>
					<AgGridColumn field="action" headerName="Action" cellRendererFramework={ActionCellRender}/>
					<AgGridColumn field="createdDate" headerName="Request Date" sortable={true} valueFormatter={dateFormatter}/>
				</AgGridReact>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/views/pending/PendingView.jsx